import { Table, TableBody, TableRow, List, ListItemButton, ListItemText, Popover } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const SelectionPopover = ({ selectionOptions, points, selectedValue, onSelect, bestOutcomeId, isSpread , isEditable}) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	const selectedRef = useRef(null);

	useEffect(() => {
		if (open) {
			// Wait for Popover to render content
			const timeout = setTimeout(() => {
				if (selectedRef.current) {
					selectedRef.current.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			}, 0); // Wait for next tick

			return () => clearTimeout(timeout);
		}
	}, [open]);

	return (
		<div>
			<Table size="small" sx={{ width: 'auto', opacity: isEditable ? 1 : 0.5 }}>
				{!isSpread && (
					<TableBody>
						<TableRow>
							<div onClick={handleClick} className="screener-ou-pill" style={{ cursor: isEditable ? 'pointer' : 'default' }}>
								O:&nbsp;{selectedValue?.selection || points}
							</div>
						</TableRow>
						<TableRow>
							<div onClick={handleClick} className="screener-ou-pill" style={{ cursor: isEditable ? 'pointer' : 'default' }}>
								U:&nbsp;{selectedValue?.selection || points}
							</div>
						</TableRow>
					</TableBody>
				)}
				{isSpread && (
					<TableBody>
						<TableRow>
							<div onClick={handleClick} className="screener-ou-pill" style={{ cursor: isEditable ? 'pointer' : 'default', width: 40, textAlign: 'center' }}>
								{selectedValue?.selection || points}
							</div>
						</TableRow>
					</TableBody>
				)}
			</Table>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				PaperProps={{
					className: 'screener-popover-paper',
					sx: { maxHeight: 300, overflowY: 'auto' },
				}}>
				<List sx={{ width: 'fit-content', maxHeight: 300, overflowY: 'auto', bgcolor: 'var(--screener-surface-elevated)', color: 'var(--screener-text)' }}>
					{selectionOptions.map((item, index) => {
						const isSelected = selectedValue?.id ? selectedValue?.id === item.id : bestOutcomeId === item.id;

						return (
							<ListItemButton
								key={index}
								selected={isSelected}
								ref={isSelected ? selectedRef : null}
								onClick={() => {
									onSelect(item);
									handleClose();
								}}>
								<ListItemText primary={item.selection} />
							</ListItemButton>
						);
					})}
				</List>
			</Popover>
		</div>
	);
};
